import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import theme from "../../../theme";
import ManageFields from "../../molecules/home-manage-fields/ManageFields";
import NewCompany from "../../molecules/home-manage-fields/NewCompany";
import ConnectToCRM from "../../molecules/home-manage-fields/ConnectToCRM";

const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paper": {
            minWidth: 1200,
            width: 'calc(100vw - 200px)',
            maxWidth: 1400,
            minHeight: 600,
            height: 'calc(100vh - 100px)',
            maxHeight: 800,
            padding: '16px 24px 8px 24px',
            borderRadius: 24,
        }
    },
    dialogTitle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: 'unset',
        color: 'black',
        fontWeight: 'bold',
        fontFamily: 'Inter',
        fontSize: '1.3rem',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: '8px 0',
        height: '50vh',
        overflowY: 'hidden',
    },
    dialogActions: {
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    fields: {
        height: '100%',
        padding: '8px 12px 60px 8px',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    card: {
        position: 'relative',
        width: 300,
        height: 'fit-content',
        minHeight: 80,
        padding: '12px 16px',
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `2px solid ${theme.colors.neutral['400']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2)',
        transition: 'all 300ms ease-in-out',
        "&:hover": {
            boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        },
    },
    checkBox: {
        padding: 'unset !important',
        marginRight: '4px !important',
        "& > svg": {
            width: '24px !important',
            height: '24px !important',
        }
    },
    icon: {
        padding: 0,
        "& > svg": {
            width: '28px !important',
            height: '28px !important'
        },
    },
    icon2: {
        width: '28px !important',
        height: '28px !important',
        fill: theme.colors.neutral['400'],
    },
    field: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#666666',
    },
    cancelBtn: {
        width: 100,
        height: 40,
        borderRadius: 40,
        background: theme.colors.neutral['100'],
        color: theme.colors.neutral['600'],
        textTransform: 'none',
        fontWeight: 'bold',
        transition: 'ease-in-out 300ms',
    },
    saveBtn: {
        width: 100,
        height: 40,
        borderRadius: 40,
        backgroundColor: theme.colors.primary['600'],
        color: 'white',
        textTransform: 'none',
        fontWeight: 'bold',
        transition: 'ease-in-out 300ms',
        '&:hover': {
            backgroundColor: theme.colors.primary['500'],
        }
    },
}));

const BuildWorkflowModal: React.FC<{
    open: boolean,
    onOpenModal?: (field?: string) => void,
    onClose: () => void,
}> = ({ open, onOpenModal, onClose }) => {
    const classes = useStyles();

    return (<>
        <Dialog className={classes.dialog} open={open} onClose={() => onClose()}>
            <DialogTitle className={classes.dialogTitle}>
                <Typography fontFamily="Inter" fontSize="1.5rem" fontWeight="bold">{'Build your ideal workflow'}</Typography>
                <Typography fontFamily="Inter" fontSize="1rem" color={theme.colors.neutral['600']}>
                    {'Customize fields that get enriched when new companies and deals get added.'}
                </Typography>
            </DialogTitle>
            <Divider sx={{ margin: '8px 0'}} />
            <DialogContent className={classes.dialogContent}>
                <Stack direction="row" alignItems="center" width="100%" height="100%" sx={{
                    backgroundImage:"radial-gradient(rgba(0,0,0,0.15) 2px, transparent 2px)",
                    backgroundSize: "25px 25px" }}>
                    <NewCompany />
                    <ManageFields onOpenModal={onOpenModal} />
                    <ConnectToCRM />
                </Stack>
            </DialogContent>
            <Divider sx={{ margin: '8px 0'}} />
            <DialogActions className={classes.dialogActions}>
                <Button className={classes.cancelBtn} onClick={onClose}> {'Cancel'} </Button>
                <Button variant="contained" className={classes.saveBtn} onClick={onClose}> {'Save'} </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default BuildWorkflowModal;
